import {classify,followingDraws} from './analysis';
import {pc28Display} from './pc28Display';

export const PC_SECTIONS=[
  ['基本类型',['大','小','单','双']],
  ['组合类型',['小单','小双','大单','大双']],
  ['极值',['极小','极大']],
  ['边类',['小边','大边','中']],
  ['特殊形态',['对子','顺子','豹子','杂六']],
  ['龙虎',['龙','虎','和']],
  ['和值（00–27）',Array.from({length:28},(_,i)=>String(i).padStart(2,'0'))],
];
export function pcAttributes(draw) {
  const {total,combination,extreme,shape}=pc28Display(draw.numbers);
  return [total>=14?'大':'小',total%2?'单':'双',combination,extreme,
    total<=9?'小边':total>=18?'大边':'中',shape==='—'?'杂六':shape,
    classify(draw,'pc','dragon'),String(total).padStart(2,'0')];
}
export function pcCategoryStats(history) {
  const labels=history.map(pcAttributes);
  return PC_SECTIONS.map(([title,items])=>({title,rows:items.map(label=>{
    const first=labels.findIndex(row=>row.includes(label));
    const count=labels.filter(row=>row.includes(label)).length;
    return {label,count,missing:first<0?history.length:first,censored:first<0,rate:history.length?count/history.length:null};
  })}));
}
// Each run occupies a column; same results stack downwards. Gaps start a new segment.
export function roadCells(history,play) {
  const ordered=[...history].reverse();
  let col=-1,row=0,previous=null;
  const cells=ordered.map((draw,i)=>{
    const value=classify(draw,'pc',play);
    const gap=i>0&&Number(draw.issue)-Number(ordered[i-1].issue)!==1;
    if(value!==previous||gap||value==='和') {col+=gap?2:1;row=0;} else row++;
    previous=value==='和'?null:value;
    return {value,issue:draw.issue,col,row,gap};
  });
  return {cells,columns:Math.max(col+1,1),rows:Math.max(6,...cells.map(cell=>cell.row+1))};
}
const theoretical=Array(28).fill(0);
for(let a=0;a<10;a++)for(let b=0;b<10;b++)for(let c=0;c<10;c++)theoretical[a+b+c]++;
export function pcNumberAnalysis(history,number) {
  const sums=history.map(draw=>draw.numbers.reduce((a,b)=>a+b,0));
  const positions=sums.flatMap((sum,i)=>sum===number?[i]:[]);
  const intervals=positions.slice(1).flatMap((position,i)=>{
    const start=positions[i];
    const continuous=history.slice(start,position).every((draw,offset)=>Number(draw.issue)-Number(history[start+offset+1].issue)===1);
    return continuous?[position-start]:[];
  });
  const following=followingDraws(history,'pc',{numbers:[number,0,0]});
  const nextSums=following.map(draw=>draw.numbers.reduce((a,b)=>a+b,0));
  const same=nextSums.filter(sum=>sum===number).length;
  const tail=nextSums.filter(sum=>sum!==number&&sum%10===number%10).length;
  const neighbor=nextSums.filter(sum=>Math.abs(sum-number)===1).length;
  return {number,opened:positions.length,total:history.length,
    rate:history.length?positions.length/history.length:null,theoretical:theoretical[number]/1000,
    missing:positions.length?positions[0]:history.length,
    meanInterval:intervals.length?intervals.reduce((a,b)=>a+b,0)/intervals.length:null,
    minInterval:intervals.length?Math.min(...intervals):null,maxInterval:intervals.length?Math.max(...intervals):null,
    followingTotal:following.length,same,tail,neighbor,
    nextCategories:pcCategoryStats(following).slice(0,2).flatMap(section=>section.rows),
    balls:[0,1,2].map(position=>Array.from({length:10},(_,number)=>({number,count:following.filter(draw=>draw.numbers[position]===number).length}))),
    nextNumbers:Array.from({length:28},(_,number)=>({number,count:nextSums.filter(sum=>sum===number).length})).sort((a,b)=>b.count-a.count||a.number-b.number).slice(0,10),
  };
}
